import { render } from "./ComponentGenericListMiniDetails.vue?vue&type=template&id=e02250b0&scoped=true"
import script from "./ComponentGenericListMiniDetails.vue?vue&type=script&lang=js"
export * from "./ComponentGenericListMiniDetails.vue?vue&type=script&lang=js"

import "./ComponentGenericListMiniDetails.vue?vue&type=style&index=0&id=e02250b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e02250b0"]])

export default __exports__